import React from 'react';
import { Box, Container, Flex, Text, Link, VStack } from '@chakra-ui/react';
import { NETWORK } from '../utils/constants';

const Footer = () => {
  return (
    <Box 
      as="footer" 
      bg="yakuza.black" 
      borderTop="4px solid"
      borderColor="yakuza.red"
      py={6}
      mt={16}
    >
      <Container maxW="1200px">
        <Flex 
          direction={{ base: 'column', md: 'row' }} 
          justify="space-between" 
          align={{ base: 'center', md: 'flex-start' }}
        >
          <Box mb={{ base: 6, md: 0 }} textAlign={{ base: 'center', md: 'left' }}>
            <Text color="yakuza.white" fontWeight="bold" mb={2}>
              YAKUZA Token Presale
            </Text>
            <Text color="yakuza.gold" fontSize="sm">
              Join the family. Powered by {NETWORK.name} Network.
            </Text>
            <Text color="yakuza.white" fontSize="xs" mt={2}>
              &copy; {new Date().getFullYear()} YAKUZA Token. All rights reserved.
            </Text>
          </Box>
          
          <VStack 
            spacing={2} 
            align={{ base: 'center', md: 'flex-end' }}
            fontSize="sm"
          >
            <Link 
              href="https://www.yakuzabossbase.com" 
              color="yakuza.white"
              _hover={{ color: 'yakuza.gold' }}
              isExternal
            >
              Website: www.yakuzabossbase.com
            </Link>
            
            <Link 
              href="https://docs.yakuzabossbase.com"
              color="yakuza.white"
              _hover={{ color: 'yakuza.gold' }}
              isExternal
            >
              Docs: docs.yakuzabossbase.com
            </Link>
            
            <Link 
              href="https://t.me/yakuzabossbase"
              color="yakuza.white"
              _hover={{ color: 'yakuza.gold' }}
              isExternal
            >
              Telegram: @yakuzabossbase
            </Link>
            
            <Link 
              href="https://x.com/yakuzabossbase"
              color="yakuza.white"
              _hover={{ color: 'yakuza.gold' }}
              isExternal
            >
              X: @yakuzabossbase
            </Link>
          </VStack>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;